import React from 'react';
import { Typography } from '@mui/material';
import CountryPortTable from '../tables/CountryPortTable';

const CountryAndPortsSection = () => {
  return (
    <>
      <Typography marginRight={1} marginTop={2} variant='h3'>
        Country and Ports
      </Typography>
      <CountryPortTable />
    </>
  );
};

export default CountryAndPortsSection;
